import { Controller, useFormContext } from 'react-hook-form'

import { DatePicker } from '@wartek-id/date-picker'
import { Text } from '@wartek-id/text-v1'
import { Textarea } from '@wartek-id/textarea'

import type { IPelaksanaanDocumentPreparationForm } from 'types/kinerja-pelaksanaan'

const MIN_YEAR = 2026

interface JadwalObservasiFormProps {
  disabled: boolean
}

export const JadwalObservasiForm = ({ disabled }: JadwalObservasiFormProps) => {
  const { control, register, formState } =
    useFormContext<IPelaksanaanDocumentPreparationForm>()
  const formErrors = formState.errors

  return (
    <div className="p-6 space-y-4">
      <Text>
        Jadwal dapat berupa perkiraan saja dan dapat diubah di luar sistem.
        Langsung diskusikan dengan Kepala SKB, ya.
      </Text>

      <div className="w-72 max-w-full space-y-1">
        <Text variant="action" as="label" htmlFor="tanggal-observasi">
          Tanggal
        </Text>
        <Controller
          control={control}
          name="observationDate"
          rules={{
            required: {
              value: true,
              message: 'Wajib dipilih',
            },
          }}
          render={({ field, fieldState }) => {
            const errorMessage = fieldState?.error?.message
            const isInvalid = !!errorMessage

            return (
              <DatePicker
                aria-describedby="tanggal-observasi-error"
                useCalendar
                value={field.value}
                minYear={MIN_YEAR}
                minValue={`${MIN_YEAR}-01-01`}
                isDisabled={disabled}
                onChange={field.onChange}
                isInvalid={isInvalid}
                errorMessage={errorMessage}
              />
            )
          }}
        />
      </div>

      {/* TODO: Temporarily hide this field until the feature is implemented */}
      <div className="max-w-full space-y-1">
        <Text variant="action" as="label" htmlFor="lokasi-observasi">
          Pertemuan (Kegiatan di mana observasi akan dilakukan)
        </Text>
        <div className="w-8/12 max-w-full">
          <Textarea
            isDisabled={disabled}
            maxLength={250}
            rows={3}
            placeholder="Contoh: Acara diskusi mingguan dengan Kepala SKB (Forum Kamisan), dsb."
            id="perangkat-pendukung"
            {...register('observationMeeting', {
              maxLength: 250,
              required: {
                value: true,
                message: 'Wajib diisi',
              },
            })}
            isInvalid={!!formErrors.observationMeeting}
            errorMessage={formErrors.observationMeeting?.message}
          />
        </div>
      </div>

      <div className="w-8/12 max-w-full space-y-1 relative">
        <Text variant="action" as="label" htmlFor="perangkat-pendukung">
          Perangkat Pendukung
        </Text>
        <Textarea
          isDisabled={disabled}
          maxLength={250}
          rows={3}
          placeholder="Contoh: Hasil pengumpulan data dari Formulir Umpan Balik dari orang tua untuk didiskusikan, dsb."
          id="perangkat-pendukung"
          {...register('observationTool', {
            maxLength: 250,
            required: {
              value: true,
              message: 'Wajib diisi',
            },
          })}
          isInvalid={!!formErrors.observationTool}
          errorMessage={formErrors.observationTool?.message}
        />
      </div>

      <div className="w-8/12 max-w-full space-y-1 relative">
        <Text variant="action" as="label" htmlFor="catatan">
          Catatan lain (Opsional)
        </Text>
        <Textarea
          maxLength={250}
          rows={3}
          id="catatan"
          isDisabled={disabled}
          placeholder="Contoh: Jam observasi. Anda juga dapat menuliskan catatan lain jika ada."
          {...register('observationNote', { maxLength: 250 })}
        />
      </div>
    </div>
  )
}
